import {
  CloudflowEngine,
  type NodeConfigSystemEventTriggerParameters,
  type UnwrappedApiServiceModelDescriptor,
} from "@doitintl/cmp-models";
import { getCollection, type WithModel } from "@doitintl/models-any";

export const getSystemEventTriggerModel = async (
  source: "systemEvents",
  event: string,
  version: string
): Promise<WithModel<UnwrappedApiServiceModelDescriptor>> => {
  const modelData = (
    await getCollection(CloudflowEngine)
      .doc("triggers")
      .collection("sources")
      .doc(source)
      .collection("models")
      .doc(event)
      .collection("versions")
      .doc(version)
      .get()
  ).asModelData();

  if (modelData === undefined) {
    throw new Error(`Unable to fetch model ${[source, event, version].join("/")}`);
  }
  return modelData;
};

export const getOutputModelBySystemEventTriggerNode = async (
  systemEventTriggerParams: NodeConfigSystemEventTriggerParameters
): Promise<WithModel<UnwrappedApiServiceModelDescriptor> | null> => {
  if (!systemEventTriggerParams) {
    return null;
  }
  const { source, event, version } = systemEventTriggerParams;
  const model = await getSystemEventTriggerModel(source, event, version);
  return model;
};
